import { render } from "./TrocarLoja.vue?vue&type=template&id=65546f9b&scoped=true"
import script from "./TrocarLoja.vue?vue&type=script&lang=js"
export * from "./TrocarLoja.vue?vue&type=script&lang=js"

import "./TrocarLoja.vue?vue&type=style&index=0&id=65546f9b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65546f9b"]])

export default __exports__